
namespace Matrix {

    export interface UrlEditorItem extends Common.AutocompleteItem {
        value: string;
    }

    @Serenity.Decorators.registerEditor('Matrix.UrlEditor', [Serenity.IReadOnly, Serenity.IStringValue])
    export class UrlEditor extends Serenity.StringEditor implements Serenity.IReadOnly {

        private queryDiv: JQuery;

        constructor(input: JQuery) {
            super(input);

            
            this.queryDiv = input.wrap('<div class="url-query-editor-wrapper"></div>')
                .parent();

            this.queryDiv.on('click', '.remove-query', e => {
                $(e.currentTarget).closest('li').remove();
                this.updateUrl();
            });

            this.queryDiv.on('change', 'input.query-key,input.query-value', e => {
                this.updateUrl();
            });

            $(`<ul></ul>`).appendTo(this.queryDiv);

            $(`<a class="add-new-query" href="javascript:;">
<i class="fa fa-plus-circle"></i> <span style="color: #aaa">
click here to add a new query</span></a>`).appendTo(this.queryDiv)
                .click((e) => {
                    $(`<li><input type="text" class="query-key required" /><em>=</em>
<input type="text" class="query-value" />
<a class="remove-query"><i class="fa fa-times text-red"></i></a>`)
                        .appendTo(this.queryDiv.children('ul')).find('input').eq(0).focus();
                });

            $(`<a class="inplace-button toggle-details" 
title="toggle query editor">
    <b><i class="fa fa-question-circle text-blue"></i></b>
</a>`).insertAfter(this.element)
                .click(() => this.queryDiv.toggleClass('query-expanded'));

            Common.autocomplete<UrlEditorItem>({
                input: input[0] as HTMLInputElement,
                fetch: (text, update, trigger) => {
                    text = Select2.util.stripDiacritics(text ?? "").toLowerCase();
                    var root = Q.resolveUrl('~/');
                    var items = $('a.nk-menu-link').toArray().map(x => {
                        var href = $(x).attr('href');
                        if (Q.startsWith(href ?? '', root))
                            href = '~/' + href.substr(root.length);

                        return <UrlEditorItem>{
                            value: href,
                            label: href + ' (' + (x as HTMLLinkElement).textContent + ')'
                        }
                    }).filter(x => x.value &&
                        !Q.startsWith(x.value, 'javascript:') &&
                        (Select2.util.stripDiacritics(x.label) ?? "").toLowerCase().indexOf(text) >= 0);

                    items = items.slice(0, 20);

                    items.sort((x, y) => x.value > y.value ? 1 : (x.value < y.value ? -1 : 0));

                    items = items.slice()

                    update(items);
                },
                minLength: 2,
                onSelect: (item, input) => {
                    $(input).val(item.value);
                }
            });

            this.element.on('change', () => this.updateQueryList());
        }

        get_readOnly(): boolean {
            return !!this.element.hasClass('readonly');
        }

        set_readOnly(value: boolean) {
            if (!!value !== this.get_readOnly()) {
                Serenity.EditorUtils.setReadonly(this.element, value);
                this.queryDiv.toggleClass('editor-readonly', !!value);
                this.queryDiv.find('.add-new-query').toggle(!value);
                this.queryDiv.find('.remove-query').toggle(!value);
            }
        }

        set_value(val: string) {
            super.set_value(val);
            this.updateQueryList();
        }

        updateQueryList() {
            var ul = this.queryDiv.children('ul').empty();
            var url = this.element.val()?.trim() ?? "";
            var idx = url.indexOf('#');
            if (idx >= 0)
                url = url.substr(0, idx);
            var idx = url.indexOf('?');
            if (idx < 0)
                return;
            var parts = url.substr(idx + 1, url.length).split('&');
            for (var i = 0; i < parts.length; i++) {
                var pair = parts[i].split('=');
                try {
                    var name = decodeURIComponent(pair[0]);
                }
                catch {
                    name = pair[0];
                }
                try {
                    var val = decodeURIComponent(Q.replaceAll(
                        Q.replaceAll(pair[1] ?? '', '{{', '%7B%7B'),
                            "}}", "%7D%7D"));
                }
                catch {
                    val = pair[1].toString();
                }
                $(`<li><input type="text" class="query-key required" value="${Q.attrEncode(name)}" /><em>=</em>
<input type="text" class="query-value" value="${Q.attrEncode(val)}" />
<a class="remove-query"><i class="fa fa-times text-red"></i></a>`)
                    .appendTo(ul);
            }
        }

        updateUrl() {
            var q = this.queryDiv.children('ul').children().toArray()
                .map(li => ({
                    key: ($(li).children('.query-key').val() ?? "").trim(),
                    value: ($(li).children('.query-value').val() ?? "").trim()
                })).filter(x => x.key.length)
                .map(x => encodeURIComponent(x.key) + "=" +
                    Q.replaceAll(Q.replaceAll(
                        encodeURIComponent(x.value ?? "") ?? '', '%7B%7B', '{{'),
                            "%7D%7D", "}}"))
                .join('&');

            var url = (this.element.val() as string)?.trim() ?? "";
            var idx = url.indexOf('#');
            var hash = idx >= 0 ? url.substr(idx) : '';
            url = idx >= 0 ? url.substr(0, idx) : url;
            idx = url.indexOf('?');
            url = (idx >= 0 ? url.substr(0, idx) : url) + (q.length > 0 ? '?' : '') + q + hash;
            this.element.val(url);
        }
    }

}